import { render } from "./App.vue?vue&type=template&id=03e7e620"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Code3\\medical-website---web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_0e94901392e05a49343df8105549c0e4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__